import React from 'react'

import { DetailItemContainer, DetailItemImage, DetailItemText } from './styled-components'

export type Props = {
  altText: string
  text: string
  imagePath: string
}

const DetailItem: React.SFC<Props> = ({ altText, imagePath, text }) => (
  <DetailItemContainer>
    <DetailItemImage src={imagePath} alt={altText} />
    <DetailItemText>{text}</DetailItemText>
  </DetailItemContainer>
)

export default DetailItem
